import { Component, OnInit, Input,Output, EventEmitter,SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sponsorship-modal',
  templateUrl: './sponsorship-modal.component.html',
  styleUrls: ['./sponsorship-modal.component.scss']
})
export class SponsorshipModalComponent implements OnInit{
  @Input() sponsors;
  @Input() type;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter();

  sponsorCount=0;
  constructor(
    private router: Router  
  ) { 
  }

  ngOnInit(): void{
    document.getElementById("backdrop").style.display = "block"
    document.getElementById("votesModal").style.display = "block"
    document.getElementById("votesModal").classList.add("show")
    
  }

  @HostListener('unloaded')
  ngOnDestroy() {
    
  }

  getSponsors (){
    let _sponsors = [];
    
    for(let sponsor of this.sponsors){
      if(sponsor.CO_Comments.indexOf('withdrew') == -1){
        _sponsors.push(sponsor.CO_Mission)
      }
    }
    this.sponsorCount = _sponsors.length
    return _sponsors.sort().join(', ');
  }
  close() {
    //alert('calling')
    document.getElementById("backdrop").style.display = "none"
    document.getElementById("votesModal").style.display = "none"
    document.getElementById("votesModal").classList.remove("show")
    this.onClose.emit(true);

  }
}
